import { DataPage } from "@/app.routes";
import { AppConfigService } from "@/services/app-config.service";
import { AuthenticationService } from "@/services/authentication.service";
import { MenuToNative, MenuToNativeId } from "@/services/bridge/bridge.service";
import { NavService } from "@/services/nav.service";
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { MatBadgeModule } from "@angular/material/badge";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { Subscription } from "rxjs";

import { TooltipDirective } from "@/directives/tooltip/tooltip.directive";
import { NgFor, NgIf, NgTemplateOutlet } from "@angular/common";
import { MatListModule } from "@angular/material/list";
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
  selector: "app-main-menu-list",
  templateUrl: "./main-menu-list.component.html",
  styleUrls: ["./main-menu-list.component.scss"],
  standalone: true,
  imports: [
    MatListModule,
    NgFor,
    NgIf,
    NgTemplateOutlet,
    RouterLink,
    RouterLinkActive,
    MatIconModule,
    MatBadgeModule,
    TranslateModule,
    TooltipDirective,
  ],
})
export class MainMenuListComponent implements OnInit, OnDestroy {
  @Input() theme: "default" | "row" = "default";

  sub = new Subscription();
  listSub = new Subscription();
  list: MenuToNative[] = [];

  themeCss: "main-menu-list-theme" | "main-menu-list-theme-row";

  constructor(
    private navService: NavService,
    private authenticationService: AuthenticationService,
    private appConfigService: AppConfigService,
    private ref: ChangeDetectorRef
  ) {}

  logout() {
    this.authenticationService.logout();
  }

  ngOnInit(): void {
    this.setThemeCss();
    this.listSub = this.navService.menuItems$.subscribe(
      (list: MenuToNative[]) => {
        this.onMenuChange(list);
      }
    );
    this.navService.currentDataPage$.subscribe((data: DataPage) => {
      this.onMenuChange(this.list);
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.listSub.unsubscribe();
  }

  setThemeCss() {
    switch (this.theme) {
      case "default":
        this.themeCss = "main-menu-list-theme";
        break;
      case "row":
        this.themeCss = "main-menu-list-theme-row";
        break;
    }
  }

  onMenuChange(list: MenuToNative[]) {
    const data = this.navService.currentDataPage$.getValue();
    if (data) {
      // level 1
      list.forEach((l) => {
        l.show = data.level === 1;
        l.showIconCollapse = data.level !== 1;
        this.ref.detectChanges();
        // level 2
        l?.childs?.forEach((c) => {
          c.show = data.level > 1 && c.id !== MenuToNativeId.PROP_MAIN;
          c.showIconCollapse = c?.childs?.length > 0;
          this.ref.detectChanges();
          // level 3
          c?.childs?.forEach((s) => {
            s.showIconCollapse = s?.childs?.length > 0;
            if (data.level === 3 && c.childs.find((t) => t.id === data.page)) {
              c.collapse = false;
            }
          });
        });
      });
    }

    this.list = list;
    this.ref.detectChanges();
  }

  toggleCollapse(e: any, item: MenuToNative) {
    e.stopPropagation();
    e.preventDefault();
    item.collapse = !item.collapse;
  }

  onItemClick(item: MenuToNative) {
    if (item.link === "logout") {
      this.logout();
    }
    if (this.appConfigService.isMobileOrTablet) {
      this.navService.toggleMainMenu();
    }
  }
}
